import * as React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "~/design-system/Button";

type ResetFilterButtonProps = {
  onClick: () => void;
};

const ResetFilterButton = (props: ResetFilterButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="ghost"
      onClick={props.onClick}
      dataClovisActionId="tasks-reset-filters"
    >
      {t(
        "screens.ProjectTasksListScreen.ResetFilterButton.title",
        "Reset filters and see all tasks"
      )}
    </Button>
  );
};

export { ResetFilterButton };
